import { render, staticRenderFns } from "./NewAdminAccountModal.vue?vue&type=template&id=6835fe84&scoped=true"
import script from "./NewAdminAccountModal.vue?vue&type=script&lang=ts"
export * from "./NewAdminAccountModal.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6835fe84",
  null
  
)

export default component.exports